<template>
  <div class="pt-4 width-100 px-4">
    <b class="font-weight-black">대출자 정보</b>
    <table
      v-if="me"
      class="my-2 font-weight-bold text-center width-100"
      :class="{ preview: isPreview }"
    >
      <tr>
        <td>성명</td>
        <td>
          <span>
            {{ me.name }}
          </span>
        </td>
      </tr>
      <tr>
        <td>생년월일</td>
        <td>{{ me.birthdate }}</td>
      </tr>
      <tr>
        <td>휴대폰 번호</td>
        <td>{{ me.phone }}</td>
      </tr>
      <tr>
        <td>상점명</td>
        <td>{{ me.store.name }}</td>
      </tr>
      <tr>
        <td>사업자등록번호</td>
        <td>{{ me.store.businessLicenseNumber }}</td>
      </tr>
      <tr>
        <td>주소</td>
        <td>{{ me.store.address1 }}</td>
      </tr>
    </table>
    <ContractAgreeButton
      description="대출자 정보에 대한 내용에"
      btn-text="확인함"
      ref="isAgree"
      :isAgree.sync="agreeForm.isAgree"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import checkAgreeMixin from './checkAgreeMixin'

export default {
  components: {
    ContractAgreeButton: () => import('@/components/loan/contract/input/ContractAgreeButton.vue'),
  },
  props: ['loan'],
  mixins: [checkAgreeMixin],
  data() {
    return {
      agreeForm: {
        isAgree: false,
      },
    }
  },
  computed: {
    ...mapState('auth', ['me']),
    isPreview() {
      return this.loan?.__preview === true
    },
  },
}
</script>

<style lang="scss" scoped>
table.preview {
  table-layout: fixed;

  td:first-of-type {
    width: 34%;
  }
}
</style>
